import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=5e2c35a4"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports